import { useEffect } from 'react'

/**
 * Sets the browser tab title for the life of the component, restoring the previous
 * title on unmount. Restoring (rather than just overwriting) means leaving an app
 * page falls back to the document's base title instead of a stale one, while the
 * pages that set titles keep the tab reflecting the current selection.
 */
export const useDocumentTitle = (title: string): void => {
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
